$(document).ready(function () {
    var $form = $("#rating-supervisor"),
        $exists = $('.exists-wrapper'),
        $noExists = $('.no-exists-wrapper'),
        $insuredWrapper = $('#insured-wrapper'),
        $company = $form.find("#company"),
        $ca = $form.find("#ca"),
        $alreadyInsured = $form.find("#already-insured"),
        $contribution = $form.find("#contribution"),
        $nextCa = $form.find('#next-ca'),
        $button = $form.find('#price'),
        $results = $form.find('#results');

    var $contactCA = $('#form_ca'),
        $contactContribution = $('#form_contribution');

    function updateLayout($checkbox) {
        if ($company.val() === 'exists') {
            $exists.show();
            $noExists.hide();
        } else {
            $exists.hide();
            $noExists.show();
        }

        if ($alreadyInsured.val() === 'insured') {
            $insuredWrapper.show();
        } else {
            $insuredWrapper.hide();
        }
    }

    function updatePrice() {
        var price = 0;

        if ($company.val() === 'exists') {
            price = calcPrice($ca.val());
            $results.html("À partir de <br><b>" + price + " &euro;/an</b>");
            $contactCA.val($ca.val());

            if ($alreadyInsured.val() === 'insured') {
                var economy = $contribution.val() - price;
                if (economy > 0) {
                    $results.append("<br>Vous pouvez économiser jusqu'à <span class='text-primary'>"+ economy +" &euro;/an</span> sur votre assurance !");
                }
                $contactContribution.val($contribution.val());
            }
        } else {
            price = calcPrice($nextCa.val());
            $results.html("À partir de <br><b>" + price + " &euro;/an</b>");
            $contactCA.val($nextCa.val());
        }

        $results.append(
            $('<div><a href="#contact" class="btn btn-primary">Je demande un devis !</a></div>')
        );
    }

    function calcPrice(ca) {
        return Math.max(Math.round(+ca * 5) / 100, 2200);
    }

    $form.find('input, select, :checkbox, :radio').on('change', function () {
        updateLayout();
    });

    $button.on('click', function (e) {
        e.preventDefault();
        updatePrice();
        return false;
    });

    if ($form.length > 0) {
        updateLayout();
    }
});
